module.exports = __webpack_public_path__ + "front/img/1.f9fded14.png";